module.exports = __webpack_public_path__ + "static/media/qqkd.2bdd7fec.svg";